<template>
  <div class="footer__newsletter__form">
    <Loader v-if="isLoading" display="absolute"></Loader>
    <Alert v-if="errorMsgs.length" type="danger" :messages="errorMsgs" />

    <Alert
      v-if="showResponse"
      type="success"
      :messages="[dictionary.responseSuccessText]" />

    <form
      v-if="!showResponse"
      ref="newsletterform"
      autocomplete="off"
      enctype="multipart/form-data"
      @submit.prevent="onSubmitForm">
      <div>
        <label for="newsletterEmail">{{ dictionary.emailLabel }}</label>
        <input
          id="newsletterEmail"
          v-model.trim="email"
          type="email"
          class="form-control form-control--white"
          :placeholder="dictionary.emailLabel"
          :class="{ 'has-error': v$.email.$error }"
          @blur="v$.email.$touch" />

        <div v-if="v$.email.$error">
          <div v-if="v$.email.required.$invalid" class="error">
            {{ dictionary.emailRequired }}
          </div>
          <div v-if="v$.email.email.$invalid" class="error">
            {{ dictionary.emailRegex }}
          </div>
        </div>
      </div>

      <!-- <input class="form-control form-control--white" type="text" placeholder="Email"> -->
      <button type="submit" class="footer__newsletter__cta">
        <span>{{ dictionary.buttonSubmitText }}</span>
      </button>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import Loader from '../components/common/Loader.vue'
import Alert from '../components/common/Alert.vue'
import * as lib from '../../lib/lib'
import useVuelidate from '@vuelidate/core'
import { email, required } from '@vuelidate/validators'
import { v4 as uuidv4 } from 'uuid'

export default {
  components: {
    Loader,
    Alert,
  },
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      // default
      componentKey: uuidv4(),
      isLoading: false,
      errorMsgs: [],
      showResponse: false,
      // form properties
      email: '',
      // reCaptchaResponse: ''
    }
  },
  validations() {
    return {
      email: { required, email },
      // reCaptchaResponse: { required }
    }
  },

  mounted() {
    // document.addEventListener('recaptcha-ready', () => {
    //   this.iniReCaptcha()
    // })
  },

  methods: {
    callbackReCaptcha(response) {
      this.reCaptchaResponse = response
    },

    expiredCallbackReCaptha() {
      this.reCaptchaResponse = ''
    },

    // iniReCaptcha() {
    //   document.getElementById('g-recaptcha').innerHTML = ''

    //   const grecaptcha = window.grecaptcha

    //   grecaptcha.render('g-recaptcha', {
    //     sitekey: this.configuration.reCaptchaPublicKey,
    //     callback: this.callbackReCaptcha,
    //     'expired-callback': this.expiredCallbackReCaptha,
    //   })
    // },

    // resetReCaptcha() {
    //   this.reCaptchaResponse = ''
    //   window.grecaptcha.reset()
    // },

    onSubmitForm() {
      this.v$.$validate()

      if (this.v$.$invalid) {
        this.$nextTick(() => {
          lib.scrollToValidation(this.scrollOffsetY)
        })
        return false
      }

      this.isLoading = true

      const formData = new FormData()

      formData.append('email', this.email)
      formData.append('__RequestVerificationToken', this.configuration.token)
      //  formData.append('g-recaptcha-response', this.reCaptchaResponse)

      axios
        .post(this.configuration.endpointSubmitData, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'X-Requested-With': 'XMLHttpRequest',
          },
        })
        .then((response) => {
          const { hasError, errorMessages } = response.data
          // response has error
          if (hasError) {
            this.handleError(errorMessages)
            return false
          }
          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    handleSuccess() {
      this.errorMsgs = []
      this.isLoading = false
      this.showResponse = true
      //  this.resetReCaptcha()
      this.resetForm()

      this.v$.$reset()
    },

    handleError(messages) {
      //  this.resetReCaptcha()
      this.errorMsgs = messages
      this.isLoading = this.showResponse = false

      console.log('  this.errorMsgs', this.errorMsgs)

      // this.$nextTick(() => {
      //   lib.scrollToError(this.scrollOffsetY)
      // })
    },

    resetForm() {
      this.email = ''
      // this.reCaptchaResponse =""
    },
  },
}
</script>
